const MACHINE_TRACKED_STAIN_TYPES = new Set(["IHC", "ISH"]);

export function isMachineTrackedStainType(
  stainType: string | null | undefined
): boolean {
  return Boolean(stainType && MACHINE_TRACKED_STAIN_TYPES.has(stainType));
}
